import { DataProducerProject } from './Project';

export interface VendorRepresentative {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: VendorRoles;
}

export interface VendorRepresentativeInput {
  email: string;
  firstName: string;
  lastName: string;
  readOnly: boolean;
}

export enum VendorRoles {
  VENDOR_TL = 'VENDOR_TL',
  VENDOR_VIEWER = 'VENDOR_VIEWER',
}

export interface VendorStats {
  connectedDevices: number;
}

type VendorContacts = {
  city: string;
  country: string;
  state?: string;
  street: string;
  zip?: number;
};

export interface Vendor {
  vendorId: string;
  vendorName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  contactInfo: VendorContacts;
  paperWorkFinished: boolean;
  vendorRepresantatives: Array<VendorRepresentative>;
  projects: Array<DataProducerProject>;
}

export interface CreateVendorInput {
  name: string;
  webSite: string;
  contactInfo: string;
  paperWorkFinished: boolean;
  groupId: string;
}

export interface CreateVendorResponse {
  createVendor: Vendor;
}

export interface ValidatorResult {
  isValid: boolean;
  errorMessage: string;
}

export type ValidatorFunction = (value: string) => ValidatorResult;

export interface FieldData {
  value: string;
  isError: boolean;
  errorMessage: string;
}
